import { put } from 'redux-saga/effects';
import { videoCommentRemoveFromStoreAction } from '../actions';
import { removeVideoCommentApi } from '../../../../common/api/videos';
import { getNewRelicAgent } from 'newRelicAgent';

export function* removeVideoCommentEffect({ payload }) {
  try {
    yield removeVideoCommentApi(payload.videoId, payload.commentId);
    yield put(videoCommentRemoveFromStoreAction(payload.commentId));
  } catch (error) {
    getNewRelicAgent().noticeError(error);
  }
}
